import { useIntl } from "react-intl";
import StatsWidget from "@rio-cloud/rio-uikit/StatsWidget";
import StatsWidgetNumber from "@rio-cloud/rio-uikit/StatsWidgetNumber";

interface IOccupancyRateProps {
    occupancyRate: number;
}

const OccupancyRate = ({ occupancyRate }: IOccupancyRateProps) => {
    const intl = useIntl();
    return (
        <StatsWidget>
            <StatsWidget.Header>{intl.formatMessage({ id: "intl-msg:dealership.occupancyRate.title" })}</StatsWidget.Header>
            <StatsWidget.Body>
                <StatsWidgetNumber
                    className="text-color-status-driving"
                    value={`${occupancyRate}%`}
                    label={intl.formatMessage({ id: "intl-msg:dealership.occupancyRate.label" })}
                />
            </StatsWidget.Body>
        </StatsWidget>
    )
}

export default OccupancyRate;